module.exports = __webpack_public_path__ + "static/media/overall-accuracy .3a22d13d.svg";